export const personalizationFieldCoreSchema = ['-span[*]', 'img[!data-mce-hubspot-object|src|class|style]'].join(',');
export const personalizationFieldMultilineSchema = ['br', 'p'].join(',');